import React, { createContext, useContext } from 'react';

import useBraze from '../hooks/useBraze';

const BrazeContext = createContext<boolean>(false);

export const BrazeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const isBrazeInitialized = useBraze();

    return (
        <BrazeContext.Provider value={isBrazeInitialized}>
            {children}
        </BrazeContext.Provider>
    );
};

export const useBrazeContext = () => useContext(BrazeContext);
